const { validator } = require('./utils/validation');

module.exports = {
  test({ rule, params }) {
    const value = params[rule.parameter];
    return value >= rule.atLeast && value <= rule.atMost;
  },

  validate: validator({
    '`parameter` property is required': rule => 'parameter' in rule,
    '`atLeast` property is required': rule => 'atLeast' in rule,
    '`atMost` property is required': rule => 'atMost' in rule,
    '`parameter` must be a string': rule => typeof rule.parameter === 'string',
    '`atLeast` must be a number': rule => typeof rule.atLeast === 'number',
    '`atMost` must be a number': rule => typeof rule.atMost === 'number',
    '`atLeast` must not exceed `atMost`': rule => rule.atLeast <= rule.atMost,  
  })
};
